import { ref } from "vue";

export function useSorting() {
    // Sorting
    const sort = ref({});

    const handleSort = (column, direction, callback = () => {}) => {
        sort.value.sort_by = column;
        sort.value.order_by = direction;

        callback();
    };

    const getSortValue = (column) => {
        if (sort.value.sort_by === column) {
            return sort.value.order_by;
        }

        return null;
    };

    return {
        sort,
        handleSort,
        getSortValue,
    };
}
